import { useMemo } from "react";

import { EditFRDMeasurementTask, FRDMeasurementTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { FrdMeasurementFormProps } from "@/types/form-types";

import { useFrdUiSchema } from "../../schema/frd-ui-schema";

import { getFrdMeasurementSchema } from "./schema/frd-measurement-schema";

export function FrdMeasurementForm(props: FrdMeasurementFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    FRDMeasurementTask | EditFRDMeasurementTask
  >({ key: "frdMeasurement", task });
  const uiSchema = useFrdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getFrdMeasurementSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editFrdMeasurement(formData);
    } else {
      await api.createFrdMeasurement(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
